import { useEffect } from 'react';
import ProveedorForm from '../../components/proveedores/ProveedorForm';
import { useCiudadesStore } from '../../stores/ciudades/ciudades.store';
import { useEstadosStore } from '../../stores/estados/estados.store';
import {
  useProveedoresStore,
  type RegistrarProveedor
} from '../../stores/proveedores/proveedores.store';

const AgregarProveedor = () => {
  const { current: proveedor, nuevo, registrar } = useProveedoresStore((state) => state);

  const { actives: ciudades, cargarActivas: cargarCiudades } = useCiudadesStore((state) => state);
  const { actives: estados, cargarActivos: cargarEstados } = useEstadosStore((state) => state);

  useEffect(() => {
    nuevo();
    cargarCiudades();
    cargarEstados();
  }, []);

  const handleSave = (values: RegistrarProveedor) => {
    return registrar(values);
  };

  return (
    <ProveedorForm
      esAgregar={true}
      proveedor={proveedor}
      ciudades={ciudades}
      estados={estados}
      onSave={handleSave}
      reloadCiudades={cargarCiudades}
    />
  );
};

export default AgregarProveedor;
